<div class="teaser">
  <base-dashboard-card-header
    header="operations.plural"
    [showBorder]="false"
    buttonLabel="action.showMore"
    [isButtonAllowed]="isButtonVisible"
    link="external-employees/list"
    [amount]="planned + active"
    [queryParams]="{ status: 'active,planned' }"
  ></base-dashboard-card-header>
  <div
    *ngIf="planned || active"
    class="bar border-round d-flex"
  >
    <div
      class="bar-inner-left position-relative"
      [routerLink]="isButtonVisible ? '/external-employees/list' : '/dashboard'"
      [queryParams]="isButtonVisible ? { status: 'active' } : {}"
      [ngStyle]="{ width: (active / (active + planned)) * 100 + '%' }"
      [ngClass]="{ 'border-round': (!planned && active) || (planned && !active), pointer: isButtonVisible }"
    >
      <div
        class="position-absolute d-none d-sm-flex justify-content-between w-100 h-100 align-items-center px-3 text-white"
      >
        <div class="info">
          <span class="info-number">{{ active }}</span>
          <span
            baseTruncate
            class="info-text"
            >{{ 'states.active' | translate | lowercase }}</span
          >
        </div>
      </div>
    </div>
    <div
      class="bar-inner-right position-relative pointer"
      routerLink="/external-employees/list"
      [queryParams]="{ status: 'planned' }"
      [ngStyle]="{ width: (planned / (active + planned)) * 100 + '%' }"
      [ngClass]="{ 'border-round': (!planned && active) || (planned && !active) }"
    >
      <div
        class="position-absolute d-none d-sm-flex justify-content-between w-100 h-100 align-items-center px-3 text-white"
      >
        <div
          class="info"
          *ngIf="planned"
        >
          <span class="info-number">{{ planned }}</span>
          <span
            baseTruncate
            class="info-text"
            >{{ '_planned' | translate }}</span
          >
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="planned || active"
    class="mt-3 d-flex d-sm-none"
  >
    <div
      class="position-relative"
      [ngStyle]="{ width: (active / (active + planned)) * 100 + '%' }"
    >
      <div class="position-absolute d-flex justify-content-between w-100 h-100 align-items-center px-3">
        <div class="info">
          <span class="info-number">{{ active }}</span>
          <span
            baseTruncate
            class="info-text"
            >{{ 'states.active' | translate | lowercase }}</span
          >
        </div>
      </div>
    </div>
    <div
      class="position-relative"
      [ngStyle]="{ width: (planned / (active + planned)) * 100 + '%' }"
    >
      <div class="position-absolute d-flex justify-content-between w-100 h-100 align-items-center px-3">
        <div
          class="info"
          *ngIf="planned"
        >
          <span class="info-number">{{ planned }}</span>
          <span
            baseTruncate
            class="info-text"
            >{{ '_planned' | translate }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
